import { destroy as destroyRF, change } from 'redux-form'
import { destroy as destroySFM, prevFetchSafe } from 'loankeeper-common/helpers/SimpleFetchManager'
// @ts-ignore
import { destroy as destroyLKG } from 'shared/LKGrid'
import { Dispatch } from 'react'
import { destroyApplicationsData, applicationSearchAgain } from 'src/store/application'

export const obtainChangeField =
  (instanceName: string) =>
  (...args: any) =>
    // @ts-ignore
    change(instanceName, ...args)

export const closeAppGrid = (instanceName: string) => destroyLKG(instanceName)

export const closeSearchBar = (instanceName: string) => destroyRF(instanceName)

// export const deleteApplications = (instanceName: string) => destroySFM(instanceName)
export const deleteApplications = (instanceName) => destroyApplicationsData(instanceName)

export const destroy = (instanceName: string, dispatch: Dispatch<any>) => {
  dispatch(closeAppGrid(instanceName))
  dispatch(closeSearchBar(instanceName))
  // dispatch(deleteApplications(instanceName))
  dispatch(deleteApplications(instanceName))
}

// export const searchAgainApplications = (instanceName: string, resolve: Function, reject: Function) =>
//   prevFetchSafe({ instanceName, resolve, reject })
export const searchAgainApplications = (instanceName: string, resolve: Function, reject: Function) =>
  applicationSearchAgain(instanceName)
